import { Store } from '../../types';

type Affiliation = 'Private Lease' | 'Private Lease Occasion' | 'Private Lease Flex' | undefined;

export const analyticsAffiliationSelector = (state: Store): Affiliation => {
	const { leaseCarData, isOccasion, isFlex } = state;

	if (!leaseCarData) return undefined;
	if (isOccasion) return 'Private Lease Occasion';
	if (isFlex) return 'Private Lease Flex';

	return 'Private Lease';
};

/**
 * Return the id of the vehicle to use in Google Analytics ecommerce events
 *
 * The id of a vehicle is a license plate for occasions. In GA events a license plate must not be logged. The
 * privateLeaseData.carId is used instead.
 * @param state
 */
export const analyticsCarIdSelector = (state: Store): number | string | undefined =>
	state.isOccasion || state.isFlex
		? state.leaseCarData?.privateLeaseData.carId
		: state.leaseCarData?.id;
